export class BillingPlanInfo {
  id: number;
  name: string;
  includeExpenseReports: boolean;
  includeMaterialDetail: boolean;
  includeTimesheets: boolean;
  transaction: string
}
